<template>
  <div :class="getClass" class="page-filtered-articles">
    <div class="page-filtered-articles__wrapper">
      <div class="page-filtered-articles__info">
        <span class="page-filtered-articles__subheader">Creating Value</span>
        <h3>
          <TextHeading color="base" variant="lg" semi>{{ title }}</TextHeading>
        </h3>
        <TheFilterArticles v-if="filter" @tabClicked="tabValue" contentText/>
        <FocusAreaLinks v-if="focusareas"></FocusAreaLinks>
        <div v-if="textarea" class="page-filtered-articles__content">
          <TextProse>
            <p>{{ textarea }}</p>
          </TextProse>
          <BaseButton :variant="getButtonStyle">Read More</BaseButton>
        </div>
      </div>
      <div class="page-filtered-articles__fig">
        <figure class="page-filtered-articles__img">
          <img v-if="tabImages" :src="getImage" alt="Alt description for the image">
          <img v-else :src="getDefaultImage" alt="Alt description for the image">
        </figure>
      </div>
    </div>
  </div>
</template>
<script>
import TextHeading from '../elements/TextHeading.vue'
import TheFilterArticles from '../components/TheFilterArticles.vue'
import FocusAreaLinks from '../components/FocusAreaLinks.vue'
import BaseButton from '../elements/BaseButton.vue'
export default {
  name: 'PageHighlightArticles',
  components: { TextHeading, TheFilterArticles, BaseButton, FocusAreaLinks },
  props: {
    subtitle: {
      type: String,
      default: 'Sub title goes here'
    },
    title: {
      type: String,
      default: 'Main title goes here'
    },
    tabImages: {
      type: Boolean,
      default: false
    },
    gradient: {
      type: Boolean,
      default: false
    },
    focusareas: {
      type: Boolean,
      default: false
    },
    textarea: {
      type: Boolean,
      default: false
    },
    filter: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedTab: '1'
    }
  },
  computed: {
    getButtonStyle() {
      return this.gradient ? 'secondary' : 'primary'
    },
    getDefaultImage() {
      return require('@/assets/images/hilmore-house-02.png')
    },
    getImage() {
      return require('@/assets/images/tabs/ar-tab' + this.selectedTab + '.jpg')
    },
    getClass() {
      return `${(this.gradient && 'page-filtered-articles--gradient') || ''}`
    }
  },
  methods: {
    tabValue(tab) {
      this.selectedTab = tab
    }
  }
}
</script>

<style lang="postcss">
.page-filtered-articles {
  @apply w-full text-body bg-body-lightest overflow-hidden mb-12;
}
.page-filtered-articles__wrapper {
  @apply w-full mx-6 flex flex-wrap;
}
.page-filtered-articles__info {
  @apply w-full py-6 flex -mx-6 flex-col justify-center;
  order: 2;
}
.page-filtered-articles__subheader,
.page-filtered-articles__info h3 span {
  @apply font-semibold px-6;
}
.page-filtered-articles h3 {
  @apply mb-3;
}
.page-filtered-articles__fig {
  @apply w-full -mx-6 flex;
  order: 1;
}
.page-filtered-articles__img {
  @apply w-full aspect-ratio-4/3 bg-body-light relative overflow-hidden;
}
.page-filtered-articles__img img {
  @apply block absolute inset-y-0 inset-x-0 min-h-full min-w-full;
  object-fit: cover;
}

.page-filtered-articles--gradient {
  @apply bg-gradient-tl-primary;
}
.page-filtered-articles--gradient span {
  @apply text-white opacity-50;
}
.page-filtered-articles--gradient h3 span,
.page-filtered-articles--gradient p {
  @apply text-white opacity-100;
}
.page-filtered-articles--gradient .page-filtered-articles__content {
  @apply text-white;
}
.page-filtered-articles__content {
  @apply w-full px-6;
}
.page-filtered-articles__content p {
  @apply mb-6 text-white;
}
@screen md {
  .page-filtered-articles {
    @apply pt-0 mb-24;
  }
  .page-filtered-articles h3 {
    @apply mb-10;
  }
  .page-filtered-articles__wrapper {
    @apply flex-no-wrap;
  }
  .page-filtered-articles__info {
    @apply w-1/2 py-24 pl-6;
    order: 1;
  }
  .page-filtered-articles__subheader,
  .page-filtered-articles__info h3 span {
    @apply px-0;
  }
  .page-filtered-articles__fig {
    @apply w-1/2 ml-auto mr-0;
    order: 2;
  }
  .page-filtered-articles__content {
    @apply px-0;
  }
}
@screen xl {
  .page-filtered-articles__img {
    @apply mr-0;
  }
  .page-filtered-articles__wrapper {
    @apply mx-auto px-6 max-w-screen-xl;
  }
}
</style>